import { IItem, instanceOfINameDisplayable } from "../items";
import { ExternalValidationResultAlert } from "../../../applications/documaker/domain/document";
import { AbstractDocumentItemAlert } from "./AbstractDocumentItemAlert";

export class ExternalValidateItemAlert extends AbstractDocumentItemAlert<IItem> {
  constructor(itemSetId: number, private readonly item: IItem, private readonly _source: ExternalValidationResultAlert) {
    super(itemSetId, item, _source.isError);
  }

  get target(): string {
    return this.itemName
      ? "「" + (this.itemName ? this.itemName : "") + "」"
      : "id:" + this._detectedItem.id;
  }

  get itemName(): string {
    return instanceOfINameDisplayable(this.item)
      ? this.item.getDisplayName()
      : null;
  }

  get kind(): string {
    return this._source.kind;
  }

  get description(): string {
    return this._source.description;
  }
}
